/** @format */

import {ReactElement} from 'react';

import {Box} from '@mui/material';

import logoImg from 'images/logo__black.svg';

import {
  StyledImage,
  StyledTypographyDescription,
  StyledTypographyTitle,
  TooltipContentContainer,
} from './styles';

const TooltipContent = (): ReactElement => {
  return (
    <TooltipContentContainer>
      <Box sx={{display: 'flex', alignItems: 'center'}}>
        <StyledTypographyTitle>Экономия с </StyledTypographyTitle>
        <StyledImage alt='AdSensor Logo' src={logoImg} />
      </Box>
      <StyledTypographyDescription>
        Модуль считает количество сэкономленных средств на основании разницы между временем, которое
        требуется специалисту на поиск ошибки без AdSensor и с помощью AdSensor.
      </StyledTypographyDescription>
      <StyledTypographyDescription>
        Полученная разница умножается на среднюю поминутную ставку диджитал-специалиста.
      </StyledTypographyDescription>
    </TooltipContentContainer>
  );
};

export default TooltipContent;
